/** Client copy for personalized daily caps (keep in sync with userUsageLimits.ts). */

export const PERSONALIZED_ANALYZE_LIMIT_MESSAGE =
  "You've reached today's limit for personalized analyses. Try again tomorrow.";

export const PERSONALIZED_REWRITE_LIMIT_MESSAGE =
  "You've reached today's limit for safer rewrites. Try again tomorrow.";
